import { render, staticRenderFns } from "./MultiFieldItem.vue?vue&type=template&id=119c35e8"
import script from "./MultiFieldItem.vue?vue&type=script&lang=js"
export * from "./MultiFieldItem.vue?vue&type=script&lang=js"
import style0 from "./MultiFieldItem.vue?vue&type=style&index=0&id=119c35e8&prod&lange=less&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports